import { useEffect } from 'react';
import { useParams } from 'react-router';

import { useAuth } from 'providers/Auth';
import { sendGaView } from 'trackers/ga';

export default function WithTracker({ children, ga, paramkey, formatter, ...props }) {
    const {
        liffAuth: { lineId }
    } = useAuth();
    const params = useParams();
    const paramValue = paramkey ? params[paramkey] : '';
    const gaName = formatter ? formatter(ga, paramValue) : ga;

    useEffect(() => {
        if (lineId && gaName) sendGaView(lineId, gaName);
    }, [lineId, gaName]);

    return <>{children}</>;
}
